import Vue from 'vue';
import apiClient from '../../apiClient';
import { dateToLocal } from '@/modules/dates';
import config from '@/config';

const state = {
  packages: [],
  history: []
};

const actions = {
  packagesGet: ({ commit }) =>
    new Promise((resolve, reject) => {
      apiClient
        .get('/tariffs')
        .then(response => {
          // const { order } = response.data;
          commit('packagesSet', response.data);
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    }),

  paymentUrlGet: (_context, { id }) =>
    new Promise((resolve, reject) => {
      apiClient
        .get(`/payment/create?package=${id}&months=1`)
        .then(response => {
          resolve(response.data.link);
        })
        .catch(err => {
          reject(err);
        });
    }),

  paymentsHistoryGet: ({ commit }, firmId) => {
    new Promise((resolve, reject) => {
      apiClient
        .get(`/firms/${firmId}/billings/balance`)
        .then(response => {
          const payments = response.data;

          // Dates to local timezone
          payments.forEach(item => {
            const dateFields = (({ created_at }) => ({
              created_at
            }))(item);
            for (const [key, value] of Object.entries(dateFields)) {
              item[key] = dateToLocal(
                value,
                config.dateTimeInputFormat,
                config.dateTimeInputFormat
              );
            }
          });
          commit('paymentsHistorySet', response.data);
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
};

const mutations = {
  packagesSet: (state, packages) => {
    Vue.set(state, 'packages', packages);
  },
  paymentsHistorySet: (state, packages) => {
    Vue.set(state, 'history', packages);
  }
};

export default {
  state,
  actions,
  mutations
};
